<template>
  <div class="paper-center">
    <!-- 轮播图 -->
    <div class="swiper">
      <Swiper boxHeight='120px' />
    </div>

    <div class="nav-bar-box">
      <div class="nav-bar">
        <el-radio-group class="nav-bar-list" v-model="navBarRoute">
          <el-radio class="nav-bar-item" label="/paper-center/volume-library">卷库</el-radio>
        </el-radio-group>

        <div>
        </div>
      </div>
    </div>

    <!-- 显示子路由 -->
    <router-view />

  </div>
</template>

<script>
// 轮播图
import Swiper from "@/components/content/Swiper";

export default {
  name: "PaperCenter",
  components: {
    Swiper
  },
  data() {
    return {
      //当前路由路径
      navBarRoute: this.$route.path
    };
  },

  watch: {
    //点击跳转子路由
    navBarRoute(newVal) {
      this.$router.push(newVal);
    }
  }
};
</script>

<style lang="less" scoped>
//激活时和悬浮时字体颜色
@acitveColor: #24ba58;
//字体基础颜色
@fontColor: #333;

.paper-center {
  .nav-bar-box {
    box-shadow: 0 0 5px 1px #ccc;
    background-color: #fff;
    height: 40px;
    display: flex;
    justify-content: center;

    .nav-bar {
      min-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 14px;
      color: @fontColor;

      .nav-bar-list {
        /deep/.el-radio__input {
          display: none;
        }

        /deep/.el-radio__label {
          font-weight: 400;
          padding-left: 0;
          margin-left: 20px;
          color: @fontColor;
        }

        /deep/.el-radio__label:hover {
          color: @acitveColor;
        }

        /deep/.el-radio__input.is-checked + .el-radio__label {
          color: @acitveColor;
        }
      }
    }
  }
}
</style>